<script>
    import {tick} from "svelte";
    import PeopleChooser from "../PeopleChooser.svelte";
    import {PAGE_ID, router, navigateTo} from "../../stores/router";
    import {getNullRequest, I_PERSON, I_REQUEST, REQUEST_LABELS, REQUEST_EXPLANATION, requestAsObject} from "../../../../../../lib/datatypes";
    import {people} from "../../stores/people";
    import {addRequest, selectRequest} from "../../stores/misc";
    import {isoDateNow} from "../../../../../../lib/dates_times";

    const getEmptyRequest = () => requestAsObject(getNullRequest());
    let add_request = getEmptyRequest();
    let person_being_edited = false;

    // $: {
    //     console.log(add_request);
    // }

    const onEditPersonClick = () => {
        person_being_edited = true;
    };
    const onPersonClick = person_id => {
        add_request.id_person = person_id;
        person_being_edited = false;
    };
    const doAddRequest = async () => {
        let result = await addRequest(add_request);
        add_request = getEmptyRequest();
        await tick();

        selectRequest(result[I_REQUEST.ID]);
        navigateTo(PAGE_ID.VIEW_REQUEST);
    };

    const onBackClick = () => {
        if($router.context.previous_page_id !== null) {
            navigateTo($router.context.previous_page_id);
        }
        else {
            navigateTo(PAGE_ID.PROMOTIONS);
        }
        add_request = getEmptyRequest();
    };
</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto" class:hidden={$router.current_page !== PAGE_ID.ADD_REQUEST}>

    <!-- Header -->
    <div class="px-4 sm:px-6 lg:px-8">

        <!--<Breadcrumbs></Breadcrumbs>-->

        <div class="h-16 flex items-center justify-between">
            <a on:click|preventDefault={onBackClick} href="/" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                <svg class="-ml-1 mr-1 h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clip-rule="evenodd" />
                </svg>
                Back
            </a>
        </div>

    </div>

    <div class="px-4 sm:px-6 lg:px-8">

        <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">Add Request</h2>

        <div class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-6 sm:gap-x-6">

            <p class="text-sm font-medium text-gray-600">{@html REQUEST_EXPLANATION}</p>

            <div class="sm:col-span-3">
                <label for="person" class="block text-sm font-medium text-gray-900">Person</label>
                {#if person_being_edited}
                    <PeopleChooser
                            type="box"
                            current_search_str=''
                            on:personClicked={(e) => onPersonClick(e.detail.id)}
                            on:cancelClicked={() => person_being_edited = false}></PeopleChooser>
                {:else}
                    <input on:focus={() => onEditPersonClick()} value="{add_request.id_person === '' ? '' : `${$people.lookup[add_request.id_person][I_PERSON.FIRST_NAME]} ${$people.lookup[add_request.id_person][I_PERSON.LAST_NAME]}`}" type="text" name="person" id="person" class="mt-1 block w-full rounded-md border-gray-300 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                {/if}
            </div>

            <div class="sm:col-span-3">
                <label for="request-title" class="block text-sm font-medium text-gray-900">Title</label>
                <input bind:value="{add_request.title}" type="text" name="request-title" id="request-title" autocomplete="request-title" class="mt-1 block w-full rounded-md border-gray-300 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                <p class="mt-3 text-sm italic text-gray-500">({@html REQUEST_LABELS.TITLE})</p>
            </div>

            <div class="sm:col-span-6">
                <label for="description" class="block text-sm font-medium text-gray-900">Description</label>
                <div class="mt-1">
                    <textarea bind:value={add_request.description}
                              id="description" name="description" rows="4"
                              class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"></textarea>
                </div>
                <p class="mt-3 text-sm italic text-gray-500">({@html REQUEST_LABELS.DESCRIPTION})</p>
            </div>

        </div>

        <div class="flex justify-end pt-8">
            <button on:click={onBackClick}
                    type="button"
                    class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >Cancel</button>
            <button on:click={doAddRequest}
                    type="submit"
                    class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >Save</button>
        </div>

    </div>

</div>


<style></style>